import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
	return (
		<div className="notfound-page">
			<h1>404 – Page non trouvée</h1>
			<p>Désolé, le chemin que vous recherchez n’existe pas.</p>
			<Link to="/" className="btn">
				Retour à l’accueil
			</Link>
		</div>
	);
}
